// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body.fullscreen .app-header{display:none}body.fullscreen .app-sidebar{display:none !important}body.fullscreen .app-wrapper{padding:0}body.fullscreen .app-footer{display:none}", ""]);
// Exports
module.exports = exports;
